import { LandingLayout } from 'layouts';
import { useParams } from 'react-router';
import { ContentLeft, Footer, Header, type HeaderItem, MagicLinkCheck } from 'features/onboarding';
import { useOnSuccessLogin, useOnboardingNavigation } from '../hooks';
import type { OnboardingLocationState } from '../types';
import { useReferrer } from './hooks';

export type CheckMagicLinkLocationState = OnboardingLocationState;

const PageCheckMagicLink = () => {
  const { token } = useParams<{ token?: string }>();
  const referrer = useReferrer();
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onSuccessLogin } = useOnSuccessLogin<CheckMagicLinkLocationState>({ referrer });
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToCheckCode, onNavigateToPrimaryLogin, onNavigateToSignUp } =
    useOnboardingNavigation<CheckMagicLinkLocationState>();

  const headerButtons: HeaderItem[] = [
    {
      label: 'Sign up',
      async onClick() {
        await onNavigateToSignUp();
      },
      type: 'primary',
    },
  ];

  return (
    <LandingLayout
      contentLeft={<ContentLeft />}
      contentRight={
        <MagicLinkCheck
          onNavigateToCheckCode={onNavigateToCheckCode}
          onNavigateToPrimaryLogin={onNavigateToPrimaryLogin}
          onSuccessLogin={onSuccessLogin}
          token={token}
        />
      }
      footer={<Footer />}
      header={<Header items={headerButtons} />}
    />
  );
};

export default PageCheckMagicLink;
